import React from "react";

type SkillsSectionProps = {
  skills: Record<string, string[]>;
};

const SkillsSection: React.FC<SkillsSectionProps> = ({ skills }) => {
  // Category-level icons
  const categoryIcons: Record<string, string> = {
    "Languages & Frameworks": "fas fa-code",
    "Cloud & DevOps": "fas fa-cloud",
    Databases: "fas fa-database",
    "Payment Gateways": "fas fa-credit-card",
    "Tools & Others": "fas fa-tools",
    "Soft Skills": "fas fa-users",
  };

  // Individual skill icons
  const skillIcons: Record<string, string> = {
    // Languages & Frameworks
    "Node.js (Express, Nest.js)": "fab fa-node-js",
    "PHP (CodeIgniter)": "fab fa-php",
    HTML: "fab fa-html5",
    CSS: "fab fa-css3-alt",
    JavaScript: "fab fa-js-square",

    // Cloud & DevOps
    "AWS (S3, EC2, Lambda, EKS, ECS, ECR, CloudFront, CodeBuild, CodePipeline)":
      "fab fa-aws",
    Docker: "fab fa-docker",
    "CI/CD": "fas fa-sync-alt",
    Git: "fab fa-git-alt",

    // Databases
    PostgreSQL: "/icons/postgresql.svg",
    MySQL: "/icons/mysql.svg",
    Couchbase: "/icons/couchbase.svg",
    Firebase: "/icons/firebase.svg",
    Supabase: "/icons/supabase.svg",
    Redis: "/icons/redis.svg",
    BigQuery: "fas fa-search",

    // Payment Gateways
    Stripe: "fab fa-stripe",
    PayPal: "fab fa-paypal",
    RazorPay: "/icons/razorpay.svg",
    Paytm: "/icons/paytm.ico",
    Solidgate: "/icons/solidgate.ico",
    PayFort: "/icons/payfort.ico",
    HyperPay: "/icons/hyperpay.svg",

    // Tools & other
    Bootstrap: "fab fa-bootstrap",
    jQuery: "/icons/jquery.svg",
    Twilio: "fas fa-sms",
    "WhatsApp Integration": "fab fa-whatsapp",
    Unifonic: "/icons/unifonic.svg",
    FFMPEG: "/icons/ffmpeg.ico",

    // Additional Skills
    "Team Management": "fas fa-users",
    Mentoring: "fas fa-chalkboard-teacher",
    "Problem Solving": "fas fa-lightbulb",
    "Quick Learning": "fas fa-graduation-cap",
    "Logic Designing": "fas fa-brain",
    "Client Communication": "fas fa-comments",
    "Prompt Engineering (AI Prompting)": "fas fa-star",
  };

  return (
    <section className="skills-section section-padding" id="skills">
      <div className="container">
        {/* Header */}
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Technical Skills</h2>
          <p className="section-subtitle">
            A comprehensive overview of my technical expertise and capabilities
          </p>
        </div>

        {/* Skills Grid */}
        <div className="skills-categories-grid">
          {Object.entries(skills).map(([category, skillList], index) => (
            <div key={index} className="skill-category theme-card">
              {/* Category Header */}
              <div className="category-header">
                <div className="category-icon">
                  <i className={categoryIcons[category] || "fas fa-star"}></i>
                </div>
                <h3>{category}</h3>
              </div>
              {/* Skill List */}
              <div className="skills-grid">
                {skillList.map((skill, i) => {
                  const icon = skillIcons[skill]; // ✅ Declare JS variable here

                  return (
                    <div key={i} className="skill-card theme-skill">
                      {icon?.endsWith(".svg") || icon?.endsWith(".ico") ? (
                        <img
                          src={icon}
                          alt={skill}
                          className="skill-svg-icon"
                        />
                      ) : (
                        <i className={icon || "fas fa-tag"}></i>
                      )}
                      <span>{skill}</span>
                    </div>
                  );
                })}
              </div>{" "}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
